import { Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import { AppState } from '@capacitor/app';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalConstants } from '../constant/constant';
import { Network } from '@capacitor/network';
import { UserService } from './user.service';
import { TimeRecordService } from './timeRecord.service';
import { EventBusService } from './event-bus.service';
import { AppEventType } from '../enums/app-events.enum';

type NetworkStatus = { currentStatus: boolean; previousStatus: boolean | null };

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  private appState: BehaviorSubject<AppState> = new BehaviorSubject<AppState>({ isActive: true });
  private networkStatusSubject: BehaviorSubject<NetworkStatus> = new BehaviorSubject<NetworkStatus>({ currentStatus: false, previousStatus: null });
  networkStatus$: Observable<NetworkStatus> = this.networkStatusSubject.asObservable();

  constructor() {
    App.addListener('appStateChange', (state: AppState) => this.setAppState(state));
    this.initializeNetworkListener();
  }

  getAppState() {
    return this.appState.asObservable();
  }

  setAppState(appState: AppState) {
    this.appState.next(appState);
  }

  private async initializeNetworkListener() {
    const status = await Network.getStatus();
    this.setNetworkStatus(status.connected);

    Network.addListener('networkStatusChange', status => {
      this.setNetworkStatus(status.connected);
    });
  }

  private setNetworkStatus(status: boolean) {
    const currentStatus = this.getCurrentNetworkStatus();
    const previousStatus = this.getPreviousNetworkStatus();
    this.networkStatusSubject.next({ currentStatus: status, previousStatus: previousStatus === null ? status : currentStatus });
    localStorage.setItem(GlobalConstants.CONNECTION_KEY, JSON.stringify(status ? 'Connected' : 'DisConnected'));
  }

  getCurrentNetworkStatus(): boolean {
    return this.networkStatusSubject.getValue().currentStatus;
  }

  getPreviousNetworkStatus(): boolean | null {
    return this.networkStatusSubject.getValue().previousStatus;
  }
}
